import React from 'react'
import BinStoreDeals, { BinStoreDealItem } from './BinStoreDeals'

type BinStoreLocation = {
  name: string
  address: string
  hours: string
  binDealsData: BinStoreDealItem[]
  locationUrl?: string
}

export const BinStoreLocation = ({
  name,
  address,
  hours,
  binDealsData,
  locationUrl,
}: BinStoreLocation) => {
  return (
    <div className="md:flex items-center justify-center">
      <div className="md:w-2/5">
        <div className="text-left pb-4 lg:pb-0">
          <div>
            <a
              href={locationUrl}
              className="text-[20px] md:text-[28px] font-extrabold cursor-pointer text-black uppercase"
            >
              {name}
            </a>
          </div>
          <div>
            <a
              href={locationUrl}
              className="text-[14px] md:text-[18px] cursor-pointer text-black font-semibold"
            >
              {address}
            </a>
          </div>
        </div>
        <div className="text-left pb-0 md:pb-0">
          <h3 className="text-[16px] md:text-[18px] leading-[42px] font-bold text-black uppercase ">
            BIN Store Hours
          </h3>

          <p className="font-medium text-[14px] md:text-[16px] text-black">
            {hours.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
      <div className="md:w-3/5">
        <BinStoreDeals binDealsData={binDealsData} />
        <p className="text-xs md:text-sm text-gray-600 text-right pr-[5%] pt-4">
          All sales are final. No discounts, no returns.
          <br />
          *Sales tax applicable.
        </p>
      </div>
    </div>
  )
}
